<template>
  <div class="work-order-detail">
    <el-row :gutter="20">
      <el-col :span="12">
        <work-order-status-info
          :work-order="wkDetailInfo"
        ></work-order-status-info>
        <work-order-base-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-base-info>
        <work-order-apply-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-apply-info>
        <work-order-user-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-user-info>
        <work-order-more-info
          :work-order="wkDetailInfo"
          label-width="110px"
          @refresh="getMyDealWorkOrderDetail"
        ></work-order-more-info>
      </el-col>
      <el-col :span="12">
        <work-order-card :isShowHeader="false">
          <work-order-tool
            slot="card-body"
            :work-order="wkDetailInfo"
            @refresh="getMyDealWorkOrderDetail"
          ></work-order-tool>
        </work-order-card>
        <el-card
          v-if="isTodoStatus && isCurrApprover"
          style="margin-bottom: 10px"
        >
          <el-tabs v-model="isActive">
            <el-tab-pane label="审批" name="approve">
              <work-order-editor ref="workOrderRef"></work-order-editor>
              <div style="text-align: center">
                <el-button
                  type="success"
                  size="small"
                  @click="handleResultClick(true)"
                  plain
                  >同意</el-button
                >
                <el-button
                  style="margin-left: 30px"
                  type="danger"
                  size="small"
                  @click="handleResultClick(false)"
                  plain
                  >不同意</el-button
                >
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-card>
        <el-card style="margin-bottom: 10px">
          <work-order-process :work-order="wkDetailInfo"></work-order-process>
        </el-card>
      </el-col>
    </el-row>
    <temp-dialog></temp-dialog>
  </div>
</template>

<script>
import api from "plus/api";
import axios from "axios";

export default {
  name: "work.myApprove.detail",
  components: {},
  data() {
    return {
      isActive: "approve",
      wkDetailInfo: {},
    };
  },
  computed: {
    wkOrderId() {
      return this.$route.query.wkOrderId;
    },
    id() {
      return this.$route.query.id;
    },
    taskId() {
      return this.$route.query.taskId;
    },
    workOrder() {
      return this.wkDetailInfo;
    },
    // 待审批
    isTodoStatus() {
      return this.workOrder && this.workOrder.handleResult === "UNDER_REVIEW";
    },
    // 当前审批人
    isCurrApprover() {
      return (
        this.wkDetailInfo &&
        this.wkDetailInfo.approver &&
        this.wkDetailInfo.approver.userId === this.$store.state.userInfo.userId
      );
    },
  },
  activated() {
    this.getMyDealWorkOrderDetail();
  },
  deactivated() {
    this.resetData();
    this.isActive = "approve";
  },
  methods: {
    resetData() {
      this.wkDetailInfo = {};
    },
    getMyDealWorkOrderDetail() {
      return api.work
        .getWorkDetail({ id: this.id })
        .then((res) => {
          const data = res.data.data;
          this.wkDetailInfo = data;
        })
        .catch((err) => {});
    },
    handleResultClick(status) {
      const editorParams = this.$refs.workOrderRef.getData();
      if (!status && !editorParams.remark) {
        return this.$message.warning("请填写反馈信息！");
      }
      const params = {
        ...editorParams,
        workOrderId: this.wkOrderId,
        taskId: this.taskId,
      };

      if (status) {
        this.$confirm("", "是否确认同意此工单申请？", {
          confirmButtonText: "同意",
          cancelButtonText: "再想想",
          type: "warning",
          center: true,
        })
          .then(() => {
            api.work.passRealtionWorkOrder(params).then((res) => {
              if (res.data.success) {
                this.$message.success("操作成功");
                this.$refs.workOrderRef.clearData();
                this.getMyDealWorkOrderDetail();
              } else {
                this.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      } else {
        this.$confirm(
          "确认后，该工单将被直接关闭。",
          "是否确认驳回此工单申请？",
          {
            confirmButtonText: "不同意",
            cancelButtonText: "再想想",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            api.work.notPassRealtionWorkOrder(params).then((res) => {
              if (res.data.success) {
                this.$message.success("操作成功");
                this.$refs.workOrderRef.clearData();
                this.getMyDealWorkOrderDetail();
              } else {
                this.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style lang="less" scoped>
.work-order-detail {
  width: 100%;

  .detail-header {
    width: 100%;
    background: #fff;
  }

  .quill-editor-container {
    padding-bottom: 32px;

    .quill-editor-box {
      position: relative;

      .quill-editor {
        padding: 20px 47px 20px 95px;
        height: 365px;

        /deep/ .ql-container {
          height: calc(100% - 42px);
        }
      }

      .quill-text-limit {
        position: absolute;
        bottom: 30px;
        right: 60px;
        color: #888;
      }
    }

    .quill-editor-options-box {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      padding-left: 95px;
      padding-right: 47px;
      position: relative;

      /deep/ .upload-file {
        font-size: 14px;

        .el-upload-list {
          padding-left: 78px;
        }

        .upload-img {
          display: flex;
          margin-top: 10px;

          .label {
            display: inline-block;
            width: 100px;
            margin-right: 12px;
            box-sizing: border-box;
            color: #3572e2;
          }
        }

        .upload-text-btn {
          color: #3572e2;
          margin-right: 12px;
        }

        .upload-limit {
          color: #999;
        }
      }
    }
  }

  .record {
    width: 100%;
    margin-top: 30px;

    .record-container {
      padding-left: 16px;
      box-sizing: border-box;
    }
  }
}

.el-button {
  width: 104px;
  height: 36px;
  border-radius: 2px;
  font-size: 14px;
}
</style>
